import r from "../themes/whiteLabel/index.mjs";
import { m as t } from "../../colors-C72eWVhK.js";
const f = (e, m = r) => t(m, e);
export {
  f as default
};
